// --- START OF FILE Acessos.js ---

import React, { useEffect, useState, useContext } from 'react';
import * as Style from './AcessosStyle';
import { AuthContext } from '../../Context/AuthContext';
import Loading from "../Loader";
import { useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';

export default function Acessos() {
    const { getAccess, access, totalAccess, authState } = useContext(AuthContext);
    const [search, setSearch] = useState('');
    const [filterPages, setFilterPages] = useState(30);
    const [offset, setOffset] = useState(0);
    const [load, setLoad] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemPerPage] = useState(10);
    const [orderFilter, setOrderFilter] = useState("desc");
    const navigate = useNavigate();
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const currentClients = access.slice(indexOfFirstItem, indexOfLastItem);

    useEffect(() => {
        if (authState.permission !== "ALL" && !authState.permission.includes("VER ACESSOS")) {
            navigate("/");
        }
        fetchAccess();
    }, []);

    const fetchAccess = async () => {
        setLoad(true);
        try {
            await getAccess(filterPages, offset, search, orderFilter);
        } catch (e) {
            console.log(e);
        } finally {
            setLoad(false);
        }
    };

    const handlePaginateFuture = async (type) => {
        var totalClientsCarregados = currentPage * itemsPerPage;
        if (type === "+") {
            if (totalClientsCarregados <= ((currentPage + 1) * itemsPerPage)) {
                setLoad(true);
                setFilterPages(filterPages + (itemsPerPage * 2));
                await fetchAccess();
                setLoad(false);
            }
            setCurrentPage(currentPage + 1);
        } else {
            if (currentPage > 1) {
                setCurrentPage(currentPage - 1);
            }
        }
    };
    
    const formatDateClients = (date) => {
        if (!date || isNaN(date.getTime())) return "Data inválida";
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${day}/${month}/${year}, ${hours}:${minutes}`;
    };

    const formatLastLogin = (timestamp) => {
        if (timestamp?.toDate) {
            return formatDateClients(timestamp.toDate());
        }
        else if (timestamp?._seconds) {
            const date = new Date(timestamp._seconds * 1000);
            return formatDateClients(date);
        }
        return "Nenhum acesso registrado";
    };

    return (
        <>
            <Style.ClientsContainer>
                <Loading load={load} />
                <Style.ContentBox>
                    <Style.Header>
                        <Style.AreaTitle>Acessos dos Clientes</Style.AreaTitle>
                    </Style.Header>

                    <Style.FilterArea>
                        <Style.SearchBar>
                            <input
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                                onKeyPress={e => e.key === 'Enter' && fetchAccess()}
                                type="text"
                                placeholder="Pesquisar por Nome ou CPF do Cliente"
                            />
                            <button onClick={() => { fetchAccess(); setCurrentPage(1); }}><FaSearch/></button>
                        </Style.SearchBar>

                        <Style.FilterGroup>
                            <label>Ordem</label>
                            <select value={orderFilter} onChange={(e) => setOrderFilter(e.target.value)}>
                                <option value="desc">Mais Recentes</option>
                                <option value="asc">Mais Antigos</option>
                            </select>
                        </Style.FilterGroup>
                    </Style.FilterArea>
                    
                    <Style.TableContainer>
                        <Style.Table>
                            <Style.TableHeader>
                                <Style.TableRow>
                                    <Style.TableHeaderCell>Nome</Style.TableHeaderCell>
                                    <Style.TableHeaderCell>CPF</Style.TableHeaderCell>
                                    <Style.TableHeaderCell>Usuário</Style.TableHeaderCell>
                                    <Style.TableHeaderCell>Último Acesso</Style.TableHeaderCell>
                                    <Style.TableHeaderCell>Acessos (Mês)</Style.TableHeaderCell>
                                </Style.TableRow>
                            </Style.TableHeader>
                            <Style.TableBody>
                                {access.length > 0 ? (
                                    currentClients.map((client, index) => (
                                        <Style.TableRow key={index}>
                                            <Style.TableCell>{client.NAME}</Style.TableCell>
                                            <Style.TableCell>{client.CPF}</Style.TableCell>
                                            <Style.TableCell>{client.USERNAME}</Style.TableCell>
                                            <Style.TableCell>{formatLastLogin(client.LASTLOGIN)}</Style.TableCell>
                                            <Style.TableCell>{client.ACCESS || 0}</Style.TableCell>
                                        </Style.TableRow>
                                    ))
                                ) : (
                                    <Style.TableRow>
                                        <Style.TableCell colSpan="5" style={{textAlign: 'center'}}>Nenhum acesso encontrado</Style.TableCell>
                                    </Style.TableRow>
                                )}
                            </Style.TableBody>
                        </Style.Table>
                    </Style.TableContainer>

                    <Style.PaginationContainer>
                        <Style.PaginationButton onClick={() => handlePaginateFuture("-")} disabled={currentPage === 1}>
                            Anterior
                        </Style.PaginationButton>
                        <span>Exibindo {indexOfFirstItem + 1} a {Math.min(indexOfLastItem, totalAccess)} de {totalAccess}</span>
                        <Style.PaginationButton onClick={() => handlePaginateFuture("+")} disabled={indexOfLastItem >= totalAccess}>
                            Próxima
                        </Style.PaginationButton>
                    </Style.PaginationContainer>
                </Style.ContentBox>
            </Style.ClientsContainer>
        </>
    );
}